var map = {
	"./about/about_banner.webp": 74394,
	"./about/about_img1.png": 79381,
	"./about/about_img2.png": 93630,
	"./about/about_img3.png": 46119,
	"./about/about_img4.png": 66504,
	"./about/about_img5.png": 60369,
	"./about/about_img6.png": 55610,
	"./about/about_mascot.webp": 20587,
	"./about/base/about_banner.png": 12531,
	"./about/base/about_img1.png": 74891,
	"./about/base/about_img2.png": 5040,
	"./about/base/about_img3.png": 1945,
	"./about/base/about_img4.png": 8870,
	"./about/base/about_img5.png": 47887,
	"./about/base/about_img6.png": 28980,
	"./about/base/about_mascot.png": 94448,
	"./contact/base/contact_alarm.png": 98796,
	"./contact/base/contact_banner.png": 19353,
	"./contact/base/contact_mascot.png": 82450,
	"./contact/base/contact_money.png": 38455,
	"./contact/base/contact_money1.png": 60910,
	"./contact/contact_alarm.png": 80124,
	"./contact/contact_alarm.webp": 95537,
	"./contact/contact_banner.jpg": 60449,
	"./contact/contact_banner.webp": 75298,
	"./contact/contact_banner1.png": 34116,
	"./contact/contact_facebook.png": 74207,
	"./contact/contact_instagram.png": 16423,
	"./contact/contact_link.png": 68011,
	"./contact/contact_mascot.png": 75266,
	"./contact/contact_mascot.webp": 36691,
	"./contact/contact_money.png": 30535,
	"./contact/contact_money1.png": 29246,
	"./contact/contact_phone.png": 96183,
	"./contact/contact_twitter.png": 98886,
	"./developers/developers1.png": 98373,
	"./developers/developers2.png": 10222,
	"./developers/developers3.png": 69591,
	"./game/about icon.png": 54148,
	"./game/bg_m-DZarrOoR.svg": 10015,
	"./game/contact icon.png": 22973,
	"./game/crash.png": 31389,
	"./game/crypto.png": 10193,
	"./game/default.jpg": 83107,
	"./game/esports.png": 29648,
	"./game/fishing.png": 60170,
	"./game/fishing_icon.png": 71108,
	"./game/game_icon.png": 22306,
	"./game/gold-coin.svg": 54636,
	"./game/gold_btn.png": 41325,
	"./game/home icon.png": 97716,
	"./game/livecasino.png": 30965,
	"./game/logo.png": 52171,
	"./game/lottery.png": 34415,
	"./game/partner icon.png": 93415,
	"./game/poker.png": 87855,
	"./game/roulette.png": 20746,
	"./game/slot_icon.png": 71220,
	"./game/slots.png": 33115,
	"./game/sports.png": 83359,
	"./game/sw1.1.png": 68664,
	"./game/sw1.10.png": 65002,
	"./game/sw1.11.png": 15763,
	"./game/sw1.12.png": 41272,
	"./game/sw1.2.png": 64275,
	"./game/sw1.3.png": 48714,
	"./game/sw1.4.png": 19141,
	"./game/sw1.5.png": 66876,
	"./game/sw1.6.png": 90807,
	"./game/sw1.7.png": 91310,
	"./game/sw1.8.png": 80697,
	"./game/sw1.9.png": 74448,
	"./game/语言.png": 59517,
	"./layout/about.png": 27043,
	"./layout/about_active.png": 52950,
	"./layout/contact.png": 43628,
	"./layout/contact_active.png": 18776,
	"./layout/home.png": 74667,
	"./layout/home_active.png": 44110,
	"./layout/lang.png": 9338,
	"./layout/partner.png": 25166,
	"./layout/partner_active.png": 69781,
	"./partners/base/partners_banner.png": 86815,
	"./partners/base/partners_icon.png": 36762,
	"./partners/base/partners_img1.png": 48831,
	"./partners/base/partners_img2.png": 63556,
	"./partners/base/partners_mascot.png": 90556,
	"./partners/partners_banner.jpg": 91937,
	"./partners/partners_banner.webp": 75010,
	"./partners/partners_banner1.png": 17476,
	"./partners/partners_icon.png": 1640,
	"./partners/partners_icon.webp": 17397,
	"./partners/partners_img1.png": 12893,
	"./partners/partners_img2.png": 31686,
	"./partners/partners_img2.webp": 86607,
	"./partners/partners_mascot.png": 23106,
	"./partners/partners_mascot.webp": 36403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;